import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useEffect
} from 'react';
import PropTypes from 'prop-types';

const DrawerContext = createContext({
  bottomDummyElementRef: null,
  scrollToBottom: () => {},
  isUserScrolledToBottom: false,
  onScroll: () => {},
  setScrollElRef: () => {},
  forceIsAtBottomCheck: () => {},
});

export const DrawerProvider = ({ children }) => {
  const [isUserScrolledToBottom, setIsUserScrolledToBottom] = useState(false);
  const bottomDummyElementRef = useRef(null);
  const [scrollEl, setScrollEl] = useState(null);

  const scrollToBottom = (behavior = 'auto') => {
    bottomDummyElementRef.current.scrollIntoView({ behavior, block: 'end', inline: 'start' });
  };

  const onScroll = (event) => {
    const drawerEl = event.target;
    // 20 is completely arbitrary, but gives a bit of margin some of the calculations.
    const isAtBottom = drawerEl.scrollHeight - drawerEl.scrollTop - drawerEl.clientHeight <= 20;
    setIsUserScrolledToBottom(isAtBottom);
  };

  const forceIsAtBottomCheck = () => {
    if (scrollEl) {
      const isAtBottom = scrollEl.scrollHeight - scrollEl.scrollTop - scrollEl.clientHeight <= 20;
      setIsUserScrolledToBottom(isAtBottom);
    }
  };

  useEffect(() => {
    // Handles initial load when there are not enough messages to cause drawer to scroll
    if (scrollEl) {
      const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
      setIsUserScrolledToBottom(!isScrollable);
    }
  }, [scrollEl]);

  const context = {
    bottomDummyElementRef,
    scrollToBottom,
    isUserScrolledToBottom,
    onScroll,
    setScrollElRef: setScrollEl,
    forceIsAtBottomCheck,
  };

  return (
    <DrawerContext.Provider value={context}>
      {children}
    </DrawerContext.Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDrawer = () => {
  return useContext(DrawerContext);
};
